module.exports = __webpack_public_path__ + "img/prizeDraw.cf377901.png";